import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';

import { initialState } from './slice';

const selectDomain = (state?: RootState) => state?.shoppingCart || initialState;

export const selectShoppingCart = createSelector([selectDomain], shoppingCart => shoppingCart);
